(function ($) {
    var doc = $(document),
        $body,
        MAXZINDEX = Number(
            $("<div>").css("z-index", 214748364809999).css("z-index")
        );
    let div_loading,
        tmpl_div_loading,
        loadingBtn =
            '<span class="c-loading spinner-grow spinner-grow-sm position-absolute ms-3 m-auto top-0 start-0" role="status" aria-hidden="true"></span>';
    // своя иконка на загрузку по ajax
    BX.showWait = function (node, msg) {
        if (typeof node === "string") {
            if (node.startsWith("comp_")) {
                node = $("#" + node);
            } else if (node.startsWith("#") || node.startsWith(".")) {
                node = $(node);
            } else {
                node = null;
            }
        }
        if (!node || (node && node.length === 0)) {
            node = $body;
            if ($(".c-loading").length === 0) $(node).append(tmpl_div_loading);
            return node;
        } else {
            let $node = $(node);
            if (
                $node.data("mini-loading") ||
                ($node[0] && $node[0].tagName === "A") ||
                ($node[0] && $node[0].tagName === "BUTTON")
            ) {
                $node.prepend(loadingBtn);
                $node.attr("disabled", "true").addClass("disabled");
                return node;
            } else if ($node[0] && $node[0].tagName === "SELECT") {
                $node.parent().prepend(loadingBtn);
                return node;
            } else if ($node[0] && $node.parents(".bx-core-adm-dialog").length) {
                node = $node.parents(".bx-core-adm-dialog");
            } else if ($node.css("position") === "static") {
                $node.css("position", "relative");
            }
        }
        if ($("#div_loading").length === 0) $(node).append(tmpl_div_loading);
        return node;
    };
    BX.closeWait = function (node, msg) {
        setTimeout(function () {
            if (!node || (node && node.length === 0)) {
                node = $(".c-loading");
            } else if (node && node.tagName === "SELECT") {
                node = $(node).parent().find(".c-loading");
            } else if (node && $(node).parents(".bx-core-adm-dialog").length) {
                node = $(node).parents(".bx-core-adm-dialog").find(".c-loading");
            } else {
                $(node).removeClass("disabled").removeAttr("disabled");
                node = $(node).find(".c-loading");
            }
            node.each(function () {
                $(this).remove();
            });
        }, 100);
    };
    // запрет резать теги в редакторе
    BX.addCustomEvent("OnEditorInitedBefore", function (toolbar) {
        var _this = this;
        //debugger;
        BX.addCustomEvent(
            this,
            "OnGetParseRules",
            BX.proxy(function () {
                _this.rules.tags.span = {};
                _this.rules.tags.svg = {};
                _this.rules.tags.use = {};
                _this.rules.tags.path = {};
                _this.rules.tags.g = {};
                _this.rules.tags.rect = {};
            }, this)
        );
    });
    BX.addCustomEvent("onAjaxSuccess", function (e) {
    });
    var bxTmp = window.VSBX;
    window.VSBX = function (node, container) {
        if (window.BX.type.isDomNode(node)) {
            return node;
        }
        if (window.BX.type.isNotEmptyString(node)) {
            if (!container) container = document;
            if (
                node.startsWith(".") ||
                node.startsWith("#") ||
                typeof container.getElementById === "undefined"
            ) {
                return container.querySelectorAll(node);
            }
            return container.getElementById(node);
        }
        if (window.BX.type.isArrayLike(node)) {
            return node[0];
        }
        if (window.BX.type.isFunction(node)) {
            return window.BX.ready(node);
        }
        return null;
    };
    window.VSBX.getTag = function (value) {
        return Object.prototype.toString.call(value);
    };
    window.VSBX.isNodeList = function (value) {
        return (
            BX.type.isObjectLike(value) && this.getTag(value) === "[object NodeList]"
        );
    };
    window.VSBX.isJQueryNode = function (node) {
        return node instanceof jQuery;
    };
    window.VSBX.in_array = function (value, array) {
        for (var i = 0; i < array.length; i++) {
            if (value == array[i]) return true;
        }
        return false;
    };
    window.VSBX.convert = {
        ToString: function (v, def) {
            if (BX.type.isNotEmptyString(v)) {
                return String(v);
            } else if (def) {
                return String(def);
            }
            return "";
        },
        ToBool: function (value) {
            if (typeof value === "boolean") return value;
            if (value === "on" || value === "true") {
                return true;
            } else if (value === "off" || value === "false") {
                return false;
            }
            return null;
        },
        StringToDate: function (str_date) {
            str_date = this.ToString(str_date).replace(
                /(\d+).(\d+).(\d+)/,
                "\$2/\$1/\$3"
            );
            let d = new Date(str_date);
            return d;
        },
        ToDate: function (date, format) {
            let str_date = this.ToString(date).replace(
                /(\d+).(\d+).(\d+)/,
                "\$2/\$1/\$3"
            );
            let d = new Date(str_date);
            let str_format = format ? format : "DD.MM.YYYY";
            if (BX.type.isFunction(window.moment)) {
                return window.moment(d).format(str_format);
            }
            return d.toLocaleDateString("ru-RU");
        },
        dbDateFormatFrom: function (date) {
            return BX.formatDate(this.StringToDate(date), "YYYY-MM-DD");
        },
        dbDateFormatTo: function (date) {
            return BX.formatDate(this.StringToDate(date), "YYYY-MM-DD 23:59:59");
        },
    };
    if (bxTmp) {
        Object.keys(bxTmp).forEach((key) => {
            window.VSBX[key] = bxTmp[key];
        });
    }

    doc.on('click', `[href="#popup_order"].popup_btn`, function () {
        event.preventDefault();
        const idPopup = $(this).attr('href');
        $('body, html').addClass('modalOpen');
        $.fancybox.close();
        $.fancybox.open({
            src: `${idPopup}`,
            type: 'inline',
            touch: false,
            autoFocus: false,
            targetClick: $(this),
            beforeClose: function () {
                $('body, html').removeClass('modalOpen');
            }
        });
    });
    /* doc.on('click', `[href="popup_order"].popup_btn`, function () {
            event.preventDefault();
            const idPopup = $(this).attr('href');
            $('body, html').addClass('modalOpen');
            $.fancybox.close();
            $.fancybox.open({
                src: `#${idPopup}`,
                type: 'inline',
                touch: false,
                autoFocus: false,
                targetClick: $(this),
                beforeClose: function () {
                    $('body, html').removeClass('modalOpen');
                }
            });
        }); */

    doc.ready(function () {
        if (!BX.getCookie("COOKIES_OK")) {
            var tCookies = `<div class="cookies">
          <div class="container">
              <div class="cookies_wrapper">
                  <p>Нажимая на кнопку «СОГЛАСЕН», Вы подтверждаете, что проинформированы об использовании на нашем сайте
                      файлов cookie и соглашаетесь с их обработкой в соответствии с <a href="/privacy-policy/#5">Политикой конфиденциальности</a>.</p>
                  <div class="cookies_btn btn">Согласен</div>
              </div>
          </div>
      </div>`;
            $("body").append(tCookies);
            doc.on("click", ".cookies .cookies_btn", function () {
                const maxAge = 3 * 24 * 60 * 60;
                BX.setCookie("COOKIES_OK", true, {path: '/', expires: maxAge});
                $('.cookies').remove();
            });
        }
        $(".menu .root-link").removeClass("active");
        $('.menu .root-link[href="' + location.pathname + '"]').addClass("active");
        $body = $("body");
        div_loading = $("#div_loading");
        tmpl_div_loading = div_loading[0] ? div_loading[0].outerHTML : "";
        if (tmpl_div_loading !== "") {
            let d = $(tmpl_div_loading);
            tmpl_div_loading = d
                .css("background", "rgb(255 255 255 / 54%)")
                .removeClass("fixed-top vh-100 vw-100")[0].outerHTML;
        }
        if (location.hash) {
            try {
                let anchor = $(location.hash);
                if (!anchor.length)
                    anchor = $('a[name="' + location.hash.replace("#", "") + '"]');
                if (anchor.length) {
                    $("html, body")
                        .stop()
                        .animate(
                            {
                                scrollTop: anchor.offset().top - 60,
                            },
                            300
                        );
                }
            } catch (error) {
            }
        }
        setTimeout(function () {
            div_loading.fadeOut(50);
            setTimeout(function () {
                div_loading.remove();
            }, 40);
        }, 70);
    });
})(jQuery);

$(document).ready(function () {

    (function () {
        const SCROLL_CLASSNAME = 'entertainment_tabs-body--scroll';
        const tabsBodyElements = document.querySelectorAll('.entertainment_tabs-body');
        if (tabsBodyElements.length === 0) return;

        tabsBodyElements.forEach(element => {
            let widthTabsBody = parseFloat(getComputedStyle(element).width);

            const tabsWrapperElement = element.querySelector('.entertainment_tabs');
            if (tabsWrapperElement) {
                const tabElements = tabsWrapperElement.querySelectorAll('.entertainment_tab');
                const firstTabElement = tabsWrapperElement.querySelector('.entertainment_tab');
                let widthOneTab,
                    widthTabs;

                if (firstTabElement) {
                    widthOneTab = parseFloat(getComputedStyle(firstTabElement).width);
                    widthTabs = widthOneTab * tabElements.length;

                    if (widthTabs > widthTabsBody) {
                        let remainder = widthTabs - widthTabsBody;
                        if (remainder > 1) {
                            element.classList.add(SCROLL_CLASSNAME);
                            let countDisplay = tabElements.length - Math.ceil(remainder / widthOneTab);
                            let tabsWrapperColumnGap = (widthTabsBody - widthOneTab * countDisplay) / (countDisplay - 1);
                            tabsWrapperElement.style.columnGap = tabsWrapperColumnGap + 'px';
                        }
                    }
                }
            }
        })
    })();

    // Обработка кликов на вкладки
    $('.entertainment_tab').click(function () {
        $('.entertainment_tab, .entertainment_content').removeClass('active');
        $(this).addClass('active');
        $('.entertainment_content').eq($(this).index()).addClass('active');

        const progressWidth = (100 / $('.entertainment_tab').length) * ($(this).index() + 1) - (100 / $('.entertainment_tab').length / 2) + '%';
        $('.entertainment_tabs-progress').css('width', progressWidth);
        if ($('.entertainment_tab').eq(-1).hasClass('active')) {
            $('.entertainment_tabs-wrapper').addClass('done');
        } else {
            $('.entertainment_tabs-wrapper').removeClass('done');
        }
    });

    $('.entertainment_tab').eq(0).click();

    // Обработка кликов на кнопки popup
    $(document).on('click', '.popup_btn', function (event) {
        event.preventDefault();
        const idPopup = $(this).attr('href');
        $('body, html').addClass('modalOpen');
        $.fancybox.close();

        window.location.hash = idPopup.includes('#')
            ? idPopup
            : '';

        $.fancybox.open({
            src: `${idPopup}`,
            type: 'inline',
            touch: false,
            autoFocus: false,
            beforeClose: function () {
                $('body, html').removeClass('modalOpen');
            },
            afterClose: function () {
                history.replaceState(null, null, ' ');
            }
        });
    });

    // проверка хэша, открытие при прямой ссылке с хэшем
    (function () {
        const popupBtn = Array.from(document.querySelectorAll('.popup_btn'));

        if (!popupBtn.length) return;

        let hashValue = window.location.hash;

        popupBtn.forEach(btn => {
            const hrefAttribute = btn.getAttribute('href');

            if (hashValue === hrefAttribute) {
                $.fancybox.open({
                    src: `${hrefAttribute}`,
                    type: 'inline',
                    touch: false,
                    autoFocus: false,
                    beforeClose: function () {
                        $('body, html').removeClass('modalOpen');
                    },
                    afterClose: function () {
                        history.replaceState(null, null, ' ');
                    }
                });
            }
        });
    })();

    // Обработка кликов на кнопки popup (old)
    /* $(document).on('click', '.popup_btn', function (event) {
            event.preventDefault();
            const idPopup = $(this).attr('href');
            $('body, html').addClass('modalOpen');
            $.fancybox.close();
            $.fancybox.open({
                src: `#${idPopup}`,
                type: 'inline',
                touch: false,
                autoFocus: false,
                beforeClose: function () {
                    $('body, html').removeClass('modalOpen');
                }
            });
        }); */


    // Обработка изменения размера окна
    $(window).on('resize', function () {
        if ($(window).width() < 992) {
            $('.gallery_items').slick('refresh');
            $('.about_hotel-img').slick('refresh');
            if ($(window).width() < 767) {
                $('.entertainment_items').slick('refresh');
            }
        }
    });

    // Обработка скролла
    window.onscroll = function () {
        let header = document.querySelector('.header');
        if (window.pageYOffset > 50) {
            header.classList.add('fixed');
        } else {
            header.classList.remove('fixed');
        }
        if (window.pageYOffset > 100 && window.pageYOffset > window.scrolltop) {
            header.classList.add('up');
        } else {
            header.classList.remove('up');
        }
        scrolltop = pageYOffset;
    };

    // Меню
    $(".menu_burger, .header_inner-close").click(function () {
        $('.menu_burger, .header_inner').toggleClass('active')
        $('body, html').toggleClass('menu_open')
    })

    $(".menu li a").click(function (e) {
        if ($(window).width() < 1200) {
            if ($(this).parent().find('.header_drop').length > 0 || $(this).parent().find('.header_drop-list').length > 0) {
                e.preventDefault();
                $('.header_drop-list li').removeClass('active');
                $(this).parent().toggleClass('active');
            }
        }
    });

    // Инициализация select2
    $("#select_local").select2({tags: ["Федеральная территория «Сириус»", "Планетарий «Сириус»", "Университет «Сириус»", "Олимпийский парк"]});
    $("#select_category").select2({tags: ["Категория1", "Категория2", "Категория3"]});
    $("#select_hotels").select2({
        tags: ["Все отели", "Alpha Sirius", "Omega Sirius", "Delta Sirius", "Gamma Sirius"],
        dropdownCssClass: 'select_type-drop'
    });
    $("#select_type").select2({tags: ["Оставить отзыв", "Задать Вопрос"], dropdownCssClass: 'select_type-drop'});
    $("#vacancy_hotel").select2({
        tags: ["Все отели", "Alpha Sirius", "Omega Sirius", "Delta Sirius", "Gamma Sirius"],
        dropdownCssClass: 'select_vacancy-drop'
    });
    $("#vacancy_category").select2({
        tags: ["Все категории", "Содержание помещений", "Прием и размещение", "Продажи и бронирование", "Электронные продажи и аналитика", "Организация общественного питания"],
        dropdownCssClass: 'select_vacancy-drop'
    });

    // Другие функциональности
    (function ($) {
        $(document).ready(function () {
            if (typeof initMap === 'function') {
                initMap();
                setTimeout(function () {
                    HOTEL_MAPS.currentZoom = 0.5;
                }, 200);
            }
        });
    })(jQuery);

    $('.cookies_btn').click(function () {
        $('.cookies').remove()
    })

    $.fn.extend({
        toggleText: function (a, b) {
            if (this.html() == a) {
                this.html(b)
            } else {
                this.html(a)
            }
        }
    });

    $('.reservation_aside-more').click(function (item) {
        $(this).prev().toggleClass('open')
        $(this).toggleText('Скрыть', 'Показать все');
    });

    $('.header_drop-item').hover(function () {
        if ($(window).width() > 1200) {
            $('.header_drop-item').not(this).removeClass('active');
            $(this).addClass('active');
            $('.header_drop-right > img').attr('src', $(this).attr('data-img'));
            $('.header_drop-logo > img').attr('src', $(this).attr('data-logo'));
            $('.header_drop-price').text($(this).attr('data-price'));
        }
    });

    $('.header_drop-item').click(function () {
        if ($(window).width() < 1200) {
            setTimeout(() => {
                $('.menu').addClass('open_list');
                $(this).addClass('open');
            }, 100);
        }
    });

    $(".header_drop-hotel").click(function (e) {
        if ($(window).width() < 1200) {
            e.preventDefault();
        }
    });

    $('.header_drop-item > .header_drop-list > li').hover(function () {
        if ($(window).width() > 1200) {
            $('.header_drop-item > .header_drop-list > li').not(this).removeClass('active');
            $(this).addClass('active');
        }
    });

    $('.header_drop-list li').hover(function () {
        if ($(window).width() > 1200) {
            $('.header_drop-right > img').attr('src', $(this).attr('data-img'));
            $('.header_drop-logo > img').attr('src', $(this).attr('data-logo'));
            $('.header_drop-price').text($(this).attr('data-price'));
        }
    });

    $(".header_drop-close").click(function (e) {
        if ($(window).width() < 1200) {
            setTimeout(() => {
                $('.menu').removeClass('open_list');
                $('.header_drop-item').removeClass('open');
            }, 200);
        }
    });

    $(".faq_item-title").click(function (e) {
        $(this).toggleClass('active');
        $(this).next().slideToggle(300);
    });

    $('.restaurants_card-more').click(function (e) {
        $(this).parent().find('.restaurants_card-text').addClass('open');
        $(this).remove();
    });

    $('#reservation_people').change(function () {
        $('.reservation_aside-done').addClass('active');
    });

    $('#reservation_child').change(function () {
        $('.reservation_aside-done').addClass('active');
        if ($(this).val() > 0) {
            $('.reservation_selection-childs').addClass('active');
            let openChild = $(this).val();
            $('.reservation_selection-child').each(function (i) {
                if (i < openChild) {
                    $(this).addClass('active');
                }
            });
        } else {
            $('.reservation_selection-childs').removeClass('active');
            let openChild = $(this).val();
            $('.reservation_selection-child').each(function (i) {
                if (i < openChild) {
                    $(this).addClass('active');
                }
            });
        }
    });

    $(".reservation_child-item").select2({
        tags: ["до 1 года", "1 год", "2 года", "3 года", "4 года", "5 лет", "6 лет", "7 лет", "8 лет", "9 лет", "10 лет", "11 лет", "12 лет", "13 лет", "14 лет", "15 лет", "16 лет"],
        dropdownCssClass: 'reservation_selection-drop'
    });

    $("#reservation_people").select2({
        tags: ["1", "2", "3", "4", "5", "6", "7"],
        dropdownCssClass: 'reservation_aside-drop'
    });

    $("#reservation_child").select2({
        tags: ["0", "1", "2", "3", "4", "5", "6"],
        dropdownCssClass: 'reservation_aside-drop'
    });

    // Инициализация календаря
    if ($('#calendar').length > 0) {
        const calendar = new VanillaCalendar('#calendar', ({
            input: true,
            actions: {
                changeToInput(e, self) {
                    if (!self.HTMLInputElement) return;
                    let date = new Date(self.selectedDates[0]);
                    let day = date.getDate();
                    let month = date.getMonth() + 1;
                    let year = date.getFullYear();
                    let formattedDate = day + "." + month + "." + year;
                    let date2 = new Date(self.selectedDates[self.selectedDates.length - 1]);
                    let day2 = date2.getDate();
                    let month2 = date2.getMonth() + 1;
                    let year2 = date2.getFullYear();
                    let formattedDate2 = day2 + "." + month2 + "." + year2;
                    if (self.selectedDates[1]) {
                        self.HTMLInputElement.value = formattedDate + ' - ' + formattedDate2;
                        self.hide();
                        self.HTMLInputElement.classList.add('active');
                    } else if (self.selectedDates[0]) {
                        self.HTMLInputElement.value = formattedDate;
                    } else {
                        self.HTMLInputElement.value = '';
                    }
                },
            },
            settings: {
                lang: 'ru',
                format: "dd.mm.yyyy",
                range: {
                    disablePast: true,
                },
                selection: {
                    day: 'multiple-ranged',
                },
                visibility: {
                    daysOutside: false,
                },
            },
        }));
        calendar.init();
    }

    // Обработка открытия модальных окон
    $('.reservation_filter').click(function () {
        $.fancybox.open({
            src: `.reservation_aside`,
            type: 'inline',
            touch: false,
            autoFocus: false,
            beforeClose: function () {
                $('body, html').removeClass('modalOpen');
            }
        });
    });

    if ($('#reservation_date').length > 0) {
        const calendar = new VanillaCalendar('#reservation_date', ({
            actions: {
                clickDay(e, self) {
                    let date = new Date(self.selectedDates[0]);
                    let day = date.getDate();
                    let month = date.getMonth() + 1;
                    if ((date.getMonth() + 1) < 10) {
                        month = '0' + (date.getMonth() + 1);
                    }
                    let year = date.getFullYear();
                    let formattedDate = day + "." + month + "." + year;
                    let date2 = new Date(self.selectedDates[self.selectedDates.length - 1]);
                    let day2 = date2.getDate();
                    let month2 = date2.getMonth() + 1;
                    if ((date.getMonth() + 1) < 10) {
                        month2 = '0' + (date2.getMonth() + 1);
                    }
                    let year2 = date2.getFullYear();
                    let formattedDate2 = day2 + "." + month2 + "." + year2;
                    if (self.selectedDates[1]) {
                        $('.reservation_date-inp').val(formattedDate + ' - ' + formattedDate2)
                    } else if (self.selectedDates[0]) {
                        $('.reservation_date-inp').val(formattedDate);
                    }
                },
                initCalendar(self) {
                    let date = new Date(self.selectedDates[0]);
                    let day = date.getDate();
                    let month = date.getMonth() + 1;
                    if ((date.getMonth() + 1) < 10) {
                        month = '0' + (date.getMonth() + 1);
                    }
                    let year = date.getFullYear();
                    let formattedDate = day + "." + month + "." + year;
                    let date2 = new Date(self.selectedDates[self.selectedDates.length - 1]);
                    let day2 = date2.getDate();
                    let month2 = date2.getMonth() + 1;
                    if ((date.getMonth() + 1) < 10) {
                        month2 = '0' + (date2.getMonth() + 1);
                    }
                    let year2 = date2.getFullYear();
                    let formattedDate2 = day2 + "." + month2 + "." + year2;
                    if (self.selectedDates[1]) {
                        $('.reservation_date-inp').val(formattedDate + ' - ' + formattedDate2)
                    } else if (self.selectedDates[0]) {
                        $('.reservation_date-inp').val(formattedDate);
                    }
                },
            },
            settings: {

                lang: 'ru',
                format: "dd.mm.yyyy",
                range: {
                    disablePast: true,
                },
                selection: {
                    day: 'multiple-ranged',
                },
                visibility: {
                    daysOutside: false,
                },
                selected: {
                    dates: ['2024-05-23', '2024-05-24'],
                },
            },

        }));
        calendar.init();
    }

    // Открытие галереи в модальном окне
    var gallery = $('.hotels_gallery-slide');
    gallery.on('click', function (e) {
        e.preventDefault();
        var totalSlides = +$(this).parents('.slider').slick("getSlick").slideCount,
            dataIndex = +$(this).parents('.slide').data('slick-index'),
            trueIndex;
        switch (true) {
            case (dataIndex < 0):
                trueIndex = totalSlides + dataIndex;
                break;
            case (dataIndex >= totalSlides):
                trueIndex = dataIndex % totalSlides;
                break;
            default:
                trueIndex = dataIndex;
        }
        $.fancybox.open(gallery, {}, trueIndex);
        return false;
    });
});

document.addEventListener('DOMContentLoaded', function () {
    (function () {
        const linksContainers = document.querySelectorAll('.restaurants__links');
        if (linksContainers) {
            linksContainers.forEach(function (container) {
                container.addEventListener('click', function () {
                    container.classList.toggle('restaurants__links--open');
                });
            });
        }
    })();
});
